import {
  API_BASE as API_BASE_ACCESS,
  NEXT_PUBLIC_API_INTERNAL_BASE as API_INTERNAL_ROUTE,
} from '@cntxt/domains/access-control';

export const API_BASE = `${API_BASE_ACCESS}/`;

/** Relative internal API path prefix (e.g. `/api/internal/`). */
export const API_INTERNAL_BASE = `${API_INTERNAL_ROUTE}/`;
